export const Caprine: { [key: string]: string } = {
  AG: 'Angora',
  AI: 'Alpine',
  BG: 'Boer',
  CS: 'Cashmere',
  EN: 'Saanen',
  GG: 'Golden Guernsey',
  KI: 'Kiko',
  LN: 'LaMancha',
  MU: 'Multiple Breeds Present',
  MX: 'Mixed Breed',
  MY: 'Myotonic',
  ND: 'Nigerian Dwarf',
  NS: 'Not Specified',
  NU: 'Nubian',
  OB: 'Oberhasli',
  OH: 'OBERHASLI',
  OT: 'Ibex',
  PG: 'Pygora',
  PY: 'Pygmy',
  RE: 'Recorded Grade',
  SB: 'SABLE',
  SP: 'Spanish',
  SV: 'Savannah',
  TO: 'Toggenburg',
  XG: 'Crossbred Goat',
};

export const Ovine: { [key: string]: string } = {
  BC: 'Border Cheviot',
  BD: 'Babydoll',
  BF: 'Bluefaced Leicester',
  BL: 'Border Leicester',
  BO: 'Booroola Merino',
  BW: 'Black Welsh Mountain',
  BX: 'Blackfaced Crossbred',
  CA: 'Canadian Arcott',
  CD: 'California Red',
  CF: 'Clun Forest',
  CL: 'Columbia',
  CM: 'California Variegated Mutant',
  CO: 'Charolais',
  CP: 'Coopworth',
  CR: 'Corriedale',
  CS: 'Cormo',
  CU: 'Cu – Lacune',
  CV: 'Cheviot',
  CW: 'Cotswold',
  CX: 'Columbia Cross',
  DE: 'Debouillet',
  DH: 'Horned Dorset',
  DM: 'Delaine Merino',
  DN: 'Durno',
  DO: 'Dorset',
  DP: 'Polled Dorper',
  EF: 'Eastern Friesian',
  FI: 'Finnsheep',
  FN: 'Finnish Landrace',
  HA: 'Hampshire',
  IF: 'Ile-de-France',
  IL: 'Icelandic',
  JA: 'Jacob',
  KA: 'Katahdin',
  KH: 'Kerry Hill',
  KK: 'Karakul',
  LA: 'Exlana',
  LE: 'Leicester',
  LI: 'Lincoln',
  LY: 'Barbados Blackbelly',
  MB: 'Bleu de Maine',
  MM: 'Merino',
  MT: 'Montadale',
  MU: 'Multiple Breeds Present',
  MX: 'Mixed Breed',
  NA: 'Navajo',
  NC: 'North Country Cheviot',
  NS: 'Not Specified',
  NT: 'Natural Colored',
  OT: 'Other',
  OX: 'Oxford',
  PA: 'Panama',
  PF: 'Perendale',
  PO: 'Polypay',
  RG: 'Rambouillet',
  RM: 'Romnelet',
  RV: 'Romanov',
  RY: 'Romney',
  SC: 'Scottish Blackface',
  SL: 'Shetland',
  SM: 'Miniature Southdown',
  SO: 'Soay',
  SR: 'Shropshire',
  ST: 'Southdown',
  SU: 'Suffolk',
  SX: 'St. Croix',
  TA: 'Targhee',
  TU: 'Tunis',
  TX: 'Texel',
  VB: 'Valais Blacknose',
  WD: 'White Dorper',
  WX: 'Whitefaced Crossbred',
  XS: 'Crossbred Sheep',
  ZW: 'Zwartbles',
};
